export default "__VITE_PUBLIC_ASSET__fa22f125__"